let baseURL = "";
if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1" || window.location.hostname === "") {
  //localhost
  baseURL = "http://localhost:4000/api";
} else {
  baseURL = "https://vmtraining-backend.vercel.app/api";
}
export { baseURL }